import { _ as _assign } from './tslib.es6-c6da0ae6.js';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import { useState, useEffect, useCallback, Suspense, lazy } from 'react';
import useWindowSize from './useWindowSize/index.js';
import { H as HeaderSkeleton } from './HeaderSkeleton-30c00961.js';
import { FontSizes, LineHeights, TypographyT4 } from '@picsart/design-system/foundation/typography';
import classNames from 'classnames';
import { Text, TextElementTypes, TypographyHorizontalAlign } from '@picsart/design-system/components/Text';
import { useTranslator } from '@picsart/rc/services/localization';
import { IconCrossLarge } from '@picsart/design-system/foundation/icons/IconCrossLarge';
import AnalyticsService from '@picsart/rc/services/analytics';
import { Button, ButtonSizeLG, ButtonSkinTertiary, ButtonVariants, ButtonElementTypes, ButtonSizeSM, ButtonSkinPrimary, ButtonSkinSecondary, ButtonSkinPremium } from '@picsart/design-system/components/Button';
import { FontWeights } from '@picsart/design-system/foundation/fonts';
import useMount from '@picsart/rc/useMount';
import { IconTshirt } from '@picsart/design-system/foundation/icons/IconTshirt';
import useDevice from '@picsart/rc/useDevice';
import { HorizontalContainer } from '@picsart/design-system/components/HorizontalContainer';
import { usePulseSettings } from '@pulse/react';
import usePageSlug from './usePageSlug/index.js';
import IS_BROWSER from './isBrowser/index.js';
import useMobileView from './useMobileView/index.js';
import { Gradients, NegativeColors, ControlBorderColors, PrimaryColors, PositiveColors, TextColors, AbsolutesWhiteColors, BackgroundColors, SecondaryColors, WarningColors, ErrorColors, AbsolutesBlackColors } from '@picsart/design-system/foundation/colors';
import { createUseStyles } from 'react-jss';
import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import data from './headerNavigation/index.js';
import dompurify from 'isomorphic-dompurify';
import { isLeftToRight, isRightToLeft, canHover, canTouch } from '@picsart/design-system/foundation/styleHelpers';
import { U as USER_SUBSCRIPTION_TYPES } from './general-9698471b.js';
import { IconMessage } from '@picsart/design-system/foundation/icons/IconMessage';
import { IconDiscoverOutline } from '@picsart/design-system/foundation/icons/IconDiscoverOutline';
import { IconSettings } from '@picsart/design-system/foundation/icons/IconSettings';
import { IconLogout } from '@picsart/design-system/foundation/icons/IconLogout';
import { IconProfileOutline } from '@picsart/design-system/foundation/icons/IconProfileOutline';
import { IconAds } from '@picsart/design-system/foundation/icons/IconAds';
import { IconGiftBox } from '@picsart/design-system/foundation/icons/IconGiftBox';
import { Easing } from '@picsart/design-system/foundation/easing';
import { Timings } from '@picsart/design-system/foundation/timings';
import { BreakPoints } from '@picsart/design-system/foundation/responsive';
import { mediaQuery } from './mediaHelper/index.js';

var BASE_100 = 'https://pastatic.picsart.com/cms-pastatic/a9c8fa42-9b48-4da0-9899-7245020d215b.png';
function AppBannerLogo() {
  return jsxs("picture", {
    children: [jsx("source", {
      srcSet: "".concat(BASE_100, "?type=webp&to=fixed&r=50, ").concat(BASE_100, "?type=webp&to=fixed&r=100 2x"),
      type: "image/webp"
    }), jsx("source", {
      srcSet: "".concat(BASE_100, "?type=png&to=fixed&r=50, ").concat(BASE_100, " 2x"),
      type: "image/png"
    }), jsx("img", {
      loading: "eager",
      src: BASE_100,
      alt: "picsart logo",
      width: "50px",
      height: "50px"
    }, "main-image")]
  });
}

var useStyles$7 = createUseStyles({
  root: {
    width: '100%',
    background: function background(_a) {
      var isHomepage = _a.isHomepage;
      return isHomepage ? Gradients.pro : NegativeColors.base["default"];
    },
    padding: [Spacings.s8, 0],
    borderTop: "1px solid ".concat(ControlBorderColors["default"]),
    borderBottom: "1px solid ".concat(ControlBorderColors["default"])
  },
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  sticky: {
    position: 'fixed',
    top: Spacings.s0,
    zIndex: 99
  },
  centerContainer: {
    display: 'flex',
    alignItems: 'center',
    flex: 1
  },
  logo: {
    marginRight: Spacings.s8,
    minWidth: 50,
    height: 50,
    background: function background(_a) {
      var isHomepage = _a.isHomepage;
      return isHomepage ? PrimaryColors.base["default"] : 'unset';
    },
    display: 'grid',
    placeItems: 'center',
    borderRadius: CornerRadius.r8,
    '& svg': {
      '& path': {
        fill: PositiveColors.base["default"]
      }
    }
  },
  closeButton: {
    background: 'transparent',
    width: 'initial',
    fill: PositiveColors.base.action,
    marginRight: Spacings.s6,
    display: 'block',
    '&:hover': {
      background: 'transparent'
    },
    '& > svg': {
      '& > path': {
        fill: PositiveColors.base.action
      }
    }
  },
  titleContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    justifyContent: 'start',
    '& >span': {
      textAlign: 'left'
    }
  },
  title: {
    display: 'block',
    fontWeight: FontWeights.semibold,
    fontSize: FontSizes.s12,
    lineHeight: LineHeights.l16,
    color: NegativeColors.text["default"]
  },
  titlesecondary: {
    fontWeight: FontWeights.medium,
    fontSize: FontSizes.s12,
    lineHeight: LineHeights.l16,
    color: function color(_a) {
      var isHomepage = _a.isHomepage;
      return isHomepage ? NegativeColors.text["default"] : TextColors.tint2;
    }
  }
}, {
  name: 'growth-rc-app-banner'
});

var appUrl = 'https://picsart.onelink.me/XqUB/g5xdlugh';
var webAppUrl = 'https://picsart.com/ai-background/';
var homeTitle = 'Studio-quality images, without the studio';
var homeSecondaryTitle = 'Get instant visuals for your product shots with Smart Background';
var homeTitleMobile = 'Studio-quality product shots';
var homeSecondaryTitleMobile = 'Forget costly shoots: try Smart Background';
var homeButtonLabel = 'Try it out';
var AppSmartBanner = function AppSmartBanner(_a) {
  var _b;
  var hideAppBanner = _a.hideAppBanner,
    screenName = _a.screenName,
    className = _a.className,
    stickyExperiment = _a.stickyExperiment;
  var translate = useTranslator();
  var isMobile = useMobileView().isMobile;
  var _c = useState(false),
    isHomepage = _c[0],
    setIsHomepage = _c[1];
  var _d = useState(isMobile),
    showBanner = _d[0],
    setBannerState = _d[1];
  var _e = useState(false),
    isSticky = _e[0],
    setSticky = _e[1];
  var isDesktop = useDevice().isDesktop;
  var languageParam = usePageSlug().languageParam;
  var styles = useStyles$7({
    isHomepage: isHomepage
  });
  var _f = usePulseSettings({
      name: 'use_feature_web_to_mobile',
      tag: 'webtomobile'
    }),
    webToMobile = _f.settings,
    loading = _f.loading;
  var title;
  var secondaryTitle;
  switch (true) {
    case isHomepage && isDesktop:
      title = homeTitle;
      secondaryTitle = homeSecondaryTitle;
      break;
    case isHomepage && !isDesktop:
      title = homeTitleMobile;
      secondaryTitle = homeSecondaryTitleMobile;
      break;
    default:
      title = 'Create photos & videos on the go';
      secondaryTitle = 'Switch to the app to start editing';
      break;
  }
  useEffect(function () {
    if (!loading && !webToMobile) {
      setIsHomepage(['/', "/".concat(languageParam), "/".concat(languageParam, "/")].includes(window.location.pathname));
    }
  }, [languageParam, loading, webToMobile]);
  useMount(function () {
    AnalyticsService.sendEvent('popup_open', {
      screen_name: "".concat(screenName, "_page"),
      name: 'mweb_install_app_banner'
    });
  });
  useEffect(function () {
    if (IS_BROWSER && !stickyExperiment) {
      var handleScroll_1 = function handleScroll_1() {
        var top = window.scrollY || document.documentElement.scrollTop;
        setSticky(top > 200);
      };
      window.addEventListener('scroll', handleScroll_1);
      return function () {
        window.removeEventListener('scroll', handleScroll_1);
      };
    }
  }, [stickyExperiment]);
  var redirect = useCallback(function () {
    if (IS_BROWSER) {
      window.location.href = isHomepage ? webAppUrl : appUrl;
    }
  }, [isHomepage]);
  var close = function close() {
    setBannerState(false);
  };
  if (!showBanner || hideAppBanner) {
    return null;
  }
  return jsx("div", _assign({
    className: classNames(styles.root, className, (_b = {}, _b[styles.sticky] = isSticky && !stickyExperiment, _b)),
    "data-testid": "app-smart-banner-test",
    "data-pulse-section": isHomepage ? 'header/smart_background_banner' : 'header/mobile-app-smart-banner'
  }, {
    children: jsxs(HorizontalContainer, _assign({
      className: styles.container
    }, {
      children: [jsx("div", _assign({
        "data-pulse-name": "Close",
        "data-pulse-clickable": true,
        onClick: close,
        onKeyDown: close
      }, {
        children: jsx(IconCrossLarge, {
          width: 24,
          height: 24,
          className: styles.closeButton,
          "data-testid": "app-banner-close-icon",
          "aria-label": "Close app banner"
        })
      })), jsxs("div", _assign({
        className: styles.centerContainer,
        "data-pulse-name": isHomepage ? homeButtonLabel : 'Open',
        "data-pulse-clickable": true,
        onClick: redirect,
        onKeyDown: redirect
      }, {
        children: [jsx("div", _assign({
          className: styles.logo
        }, {
          children: isHomepage ? jsx(IconTshirt, {}) : jsx(AppBannerLogo, {})
        })), jsxs("div", _assign({
          className: classNames(isHomepage && styles.titleContainer)
        }, {
          children: [jsx(Text, _assign({
            className: styles.title,
            elementType: TextElementTypes.Span,
            size: TypographyT4,
            weight: FontWeights.bold,
            align: TypographyHorizontalAlign.Center
          }, {
            children: translate(title)
          })), jsx(Text, _assign({
            className: styles.titlesecondary,
            elementType: TextElementTypes.Span,
            size: TypographyT4,
            weight: FontWeights.bold,
            align: TypographyHorizontalAlign.Center
          }, {
            children: translate(secondaryTitle)
          }))]
        }))]
      })), jsx(Button, _assign({
        size: ButtonSizeLG,
        skin: ButtonSkinTertiary,
        "data-testid": "button",
        "data-pulse-name": isHomepage ? homeButtonLabel : 'Open',
        variant: ButtonVariants.Filled,
        tag: ButtonElementTypes.Button,
        onClick: redirect
      }, {
        children: translate(isHomepage ? homeButtonLabel : 'Open')
      }))]
    }))
  }));
};

var useStyles$6 = createUseStyles({
  root: {
    width: '100%',
    background: Gradients.pro,
    padding: [Spacings.s8, 0]
  },
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  centerContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: Spacings.s16,
    justifyContent: 'center',
    flex: 1
  },
  bannerText: {
    '& a': {
      color: AbsolutesWhiteColors.base["default"],
      textDecoration: 'underline'
    }
  },
  closeButton: {
    background: 'transparent',
    width: 'initial',
    fill: PositiveColors.base["default"],
    marginRight: Spacings.s6,
    display: 'block',
    cursor: 'pointer',
    '&:hover': {
      background: 'transparent'
    },
    '& > svg': {
      '& > path': {
        fill: PositiveColors.base.action
      }
    }
  }
}, {
  name: 'growth-rc-app-promo-banner'
});

var AppPromoBanner = function AppPromoBanner(_a) {
  var _b = _a.hideBanner,
    hideBanner = _b === void 0 ? true : _b,
    screenName = _a.screenName,
    className = _a.className,
    _c = _a.buttonLink,
    buttonLink = _c === void 0 ? '/create' : _c,
    _d = _a.buttonText,
    buttonText = _d === void 0 ? 'Create' : _d,
    _e = _a.text,
    text = _e === void 0 ? 'Create photos & videos on the go' : _e,
    _f = _a.mobileText,
    mobileText = _f === void 0 ? 'Create Mobile Text' : _f;
  var translate = useTranslator();
  var isMobile = useMobileView().isMobile;
  var _g = useState(true),
    showBanner = _g[0],
    setBannerState = _g[1];
  var styles = useStyles$6();
  useMount(function () {
    AnalyticsService.sendEvent('popup_open', {
      screen_name: "".concat(screenName, "_page"),
      name: 'mweb_install_app_banner'
    });
  });
  var redirect = useCallback(function () {
    window.location.href = buttonLink;
  }, [buttonLink]);
  var close = function close() {
    setBannerState(false);
  };
  if (!showBanner || hideBanner) {
    return null;
  }
  return jsx("div", _assign({
    className: classNames(styles.root, className),
    "data-testid": "app-promo-banner-test"
  }, {
    children: jsxs(HorizontalContainer, _assign({
      className: styles.container
    }, {
      children: [jsxs("div", _assign({
        className: styles.centerContainer,
        "data-pulse-name": buttonText,
        "data-pulse-clickable": true,
        onClick: redirect,
        onKeyDown: redirect
      }, {
        children: [text && jsx(Text, _assign({
          color: AbsolutesWhiteColors.base["default"],
          size: TypographyT4,
          weight: FontWeights.semibold,
          className: styles.bannerText
        }, {
          children: isMobile && mobileText ? jsx("div", {
            dangerouslySetInnerHTML: {
              __html: dompurify.sanitize(mobileText)
            }
          }) : translate(text)
        })), !isMobile && jsx(Button, _assign({
          size: ButtonSizeSM,
          skin: ButtonSkinTertiary,
          "data-testid": "button",
          "data-pulse-name": buttonText,
          variant: ButtonVariants.Outline,
          tag: ButtonElementTypes.Button,
          onClick: redirect
        }, {
          children: translate(buttonText)
        }))]
      })), jsx("div", _assign({
        "data-pulse-name": "Close",
        "data-pulse-clickable": true,
        onClick: close,
        onKeyDown: close
      }, {
        children: jsx(IconCrossLarge, {
          width: 24,
          height: 24,
          className: styles.closeButton,
          "data-testid": "app-promo-banner-close-icon",
          "aria-label": "Close app banner"
        })
      }))]
    }))
  }));
};

var DesktopHeader = /*#__PURE__*/lazy(function () {
  return import('./index-fe02c55b.js');
});
var MobileHeader = /*#__PURE__*/lazy(function () {
  return import('./index-2d7e8685.js');
});
function Header(_a) {
  var _b = _a.data,
    data$1 = _b === void 0 ? data : _b,
    hideAppBanner = _a.hideAppBanner,
    applicationName = _a.applicationName,
    className = _a.className,
    storageData = _a.storageData,
    creditsData = _a.creditsData,
    hideNavigation = _a.hideNavigation,
    showProfileFeed = _a.showProfileFeed,
    showReferToEarn = _a.showReferToEarn,
    hideSearchButton = _a.hideSearchButton,
    logoBehavior = _a.logoBehavior,
    isMaximizer = _a.isMaximizer,
    promoBannerProps = _a.promoBannerProps;
  var width = useWindowSize().width;
  var isMobileHeader = width <= 1085;
  return jsx(Suspense, _assign({
    fallback: jsx(HeaderSkeleton, {
      isMobileHeader: isMobileHeader,
      logoBehavior: logoBehavior
    })
  }, {
    children: isMobileHeader ? jsxs(Fragment, {
      children: [jsx(AppPromoBanner, _assign({}, promoBannerProps)), jsx(AppSmartBanner, {
        hideAppBanner: hideAppBanner,
        screenName: applicationName,
        stickyExperiment: true
      }), jsx(MobileHeader, {
        className: className,
        data: data$1,
        storageData: storageData,
        creditsData: creditsData,
        hideNavigation: hideNavigation,
        showProfileFeed: showProfileFeed,
        showReferToEarn: showReferToEarn,
        hideSearchButton: hideSearchButton,
        logoBehavior: logoBehavior,
        isMaximizer: isMaximizer
      })]
    }) : jsxs(Fragment, {
      children: [jsx(AppPromoBanner, _assign({}, promoBannerProps)), jsx(DesktopHeader, {
        className: className,
        data: data$1,
        storageData: storageData,
        creditsData: creditsData,
        hideNavigation: hideNavigation,
        showProfileFeed: showProfileFeed,
        showReferToEarn: showReferToEarn,
        hideSearchButton: hideSearchButton,
        logoBehavior: logoBehavior,
        isMaximizer: isMaximizer
      })]
    })
  }));
}

var _a$6, _b$3, _c$1, _d$1;
var _e;
var useStyles$5 = createUseStyles({
  root: {
    display: 'none',
    position: 'absolute',
    top: '100%',
    backgroundColor: PositiveColors.base["default"],
    border: "1px solid ".concat(BackgroundColors.base, ")"),
    borderRadius: [0, 0, CornerRadius.r8, CornerRadius.r8],
    boxShadow: "0px 8px 12px ".concat((_e = SecondaryColors.alpha) === null || _e === void 0 ? void 0 : _e.alpha20),
    overflow: 'hidden',
    zIndex: 13,
    '@media screen and (max-height: 1640px)': {
      maxHeight: 'calc(100vh - 120px)',
      overflow: 'auto'
    },
    '&.navigation:not(.toRight)': (_a$6 = {
      padding: [Spacings.s0, Spacings.s12]
    }, _a$6[isLeftToRight] = {
      left: Spacings.s0
    }, _a$6[isRightToLeft] = {
      right: Spacings.s0
    }, _a$6['&.isFullWidth'] = (_b$3 = {}, _b$3[isLeftToRight] = {
      left: -180
    }, _b$3), _a$6),
    '&.optimized': {
      padding: [Spacings.s0, Spacings.s16, Spacings.s0, Spacings.s24]
    },
    '&.toRight': (_c$1 = {}, _c$1[isLeftToRight] = {
      right: Spacings.s0
    }, _c$1[isRightToLeft] = {
      left: Spacings.s0
    }, _c$1['& .has-see-more'] = {
      paddingBottom: Spacings.s0
    }, _c$1),
    '&.profile': (_d$1 = {
      padding: [Spacings.s16, Spacings.s12]
    }, _d$1[isLeftToRight] = {
      right: Spacings.s0
    }, _d$1[isRightToLeft] = {
      left: Spacings.s0
    }, _d$1)
  }
}, {
  name: 'rc-header-dev-drop-down'
});

var _a$5;
var STORAGE_STATES;
(function (STORAGE_STATES) {
  STORAGE_STATES["default"] = "default";
  STORAGE_STATES["warning"] = "warning";
  STORAGE_STATES["full"] = "full";
})(STORAGE_STATES || (STORAGE_STATES = {}));
var StorageSources;
(function (StorageSources) {
  StorageSources["RECENT_PROJECTS"] = "recent_projects";
  StorageSources["MY_FILES"] = "my_files";
  StorageSources["PROFILE"] = "profile";
  StorageSources["LEFT_NAVIGATION"] = "left_navigation";
  StorageSources["CREATE_FLOW"] = "create_flow";
})(StorageSources || (StorageSources = {}));
var StorageOrigins;
(function (StorageOrigins) {
  StorageOrigins["CREATE_FLOW"] = "create_flow";
  StorageOrigins["PROFILE"] = "profile";
  StorageOrigins["PHOTO_EDITOR"] = "photo_editor";
  StorageOrigins["MY_FILES"] = "my_files";
  StorageOrigins["TOP_NAVIGATION"] = "top_navigation";
})(StorageOrigins || (StorageOrigins = {}));
var StorageTypes;
(function (StorageTypes) {
  StorageTypes["NORMAL"] = "storage_normal";
  StorageTypes["ALMOST_FULL"] = "storage_almost_full";
  StorageTypes["FULL"] = "storage_full";
})(StorageTypes || (StorageTypes = {}));
var DRIVE_ANALYTICS_SOURCE_KEY = 'drive-analytics-source';
var ANALYTIC_EVENTS = {
  STORAGE_INFO_CLICK: 'storage_info_click',
  STORAGE_INFO_VIEW: 'storage_info_view',
  CHECKOUT_SCREEN_OPEN: 'checkout_screen_open',
  SUBSCRIPTION_DONE: 'subscription_done'
};
var BUTTON_TYPES = {
  MANAGE: 'manage',
  UPGRADE: 'upgrade'
};
var defaultTitle = 'Current Storage';
var manageStorage = 'Manage storage';
var upgradeToPro = 'Upgrade to Pro';
var upgrade = 'Upgrade';
var freeUserTexts;
(function (freeUserTexts) {
  freeUserTexts["default"] = "Enjoy up to 20 GB more storage and other premium perks.";
  freeUserTexts["warningDefault"] = "Manage your current files to free up space or upgrade your plan. ";
  freeUserTexts["fullDefault"] = "Your storage is full. Upgrade for 20 GB more space to save your work. ";
})(freeUserTexts || (freeUserTexts = {}));
var defaultColor = SecondaryColors.base["default"];
var warningColor = WarningColors.base["default"];
var fullColor = ErrorColors.base["default"];
var goldUserTexts;
(function (goldUserTexts) {
  goldUserTexts["warningDefault"] = "Your storage is almost full. Manage your current files to free up space.";
  goldUserTexts["fullDefault"] = "Your storage is full. Free up space by managing your files.";
})(goldUserTexts || (goldUserTexts = {}));
var expiredUserTexts;
(function (expiredUserTexts) {
  expiredUserTexts["fullDefault"] = "You\u2019ve exceeded your storage limit. Manage your current files to free up space or upgrade your plan.";
})(expiredUserTexts || (expiredUserTexts = {}));
var DriveAnalyticsSourceOptions;
(function (DriveAnalyticsSourceOptions) {
  DriveAnalyticsSourceOptions["Direct"] = "direct";
  DriveAnalyticsSourceOptions["LeftNavigationMyFiles"] = "left_navigation_my_files";
  DriveAnalyticsSourceOptions["LeftNavigationSharedWithMe"] = "left_navigation_shared_with_me";
  DriveAnalyticsSourceOptions["LeftNavigationStorageInfo"] = "left_navigation_storage_info";
  DriveAnalyticsSourceOptions["ProfileIconStorageInfo"] = "profile_icon_storage_info";
  DriveAnalyticsSourceOptions["RecentProjects"] = "recent_projects";
})(DriveAnalyticsSourceOptions || (DriveAnalyticsSourceOptions = {}));
var userStorageData = (_a$5 = {}, _a$5[USER_SUBSCRIPTION_TYPES.free] = {
  "default": {
    title: defaultTitle,
    text: freeUserTexts["default"],
    needMonetization: true,
    buttonText: upgrade,
    color: defaultColor,
    buttonColor: ButtonSkinPrimary
  },
  full: {
    title: defaultTitle,
    text: freeUserTexts.fullDefault,
    needMonetization: true,
    buttonText: upgradeToPro,
    color: fullColor,
    buttonColor: ButtonSkinPrimary
  },
  warning: {
    title: defaultTitle,
    text: freeUserTexts.warningDefault,
    needMonetization: true,
    buttonText: upgrade,
    color: warningColor,
    buttonColor: ButtonSkinPrimary
  }
}, _a$5[USER_SUBSCRIPTION_TYPES.gold] = {
  "default": {
    title: defaultTitle,
    text: '',
    needMonetization: false,
    buttonText: manageStorage,
    color: defaultColor,
    buttonColor: ButtonSkinPrimary
  },
  full: {
    title: defaultTitle,
    text: goldUserTexts.fullDefault,
    needMonetization: false,
    buttonText: manageStorage,
    color: fullColor,
    buttonColor: ButtonSkinPrimary
  },
  warning: {
    title: defaultTitle,
    text: goldUserTexts.warningDefault,
    needMonetization: true,
    buttonText: manageStorage,
    color: warningColor,
    buttonColor: ButtonSkinPrimary
  }
}, _a$5[USER_SUBSCRIPTION_TYPES.plus] = {
  "default": {
    title: defaultTitle,
    text: '',
    needMonetization: true,
    buttonText: upgrade,
    color: defaultColor,
    buttonColor: ButtonSkinSecondary
  },
  full: {
    title: defaultTitle,
    text: goldUserTexts.fullDefault,
    needMonetization: true,
    buttonText: upgrade,
    color: fullColor,
    buttonColor: ButtonSkinSecondary
  },
  warning: {
    title: defaultTitle,
    text: goldUserTexts.warningDefault,
    needMonetization: true,
    buttonText: upgrade,
    color: warningColor,
    buttonColor: ButtonSkinSecondary
  }
}, _a$5[USER_SUBSCRIPTION_TYPES.pro] = {
  "default": {
    title: defaultTitle,
    text: '',
    needMonetization: false,
    buttonText: upgrade,
    color: defaultColor,
    buttonColor: ButtonSkinSecondary
  },
  full: {
    title: defaultTitle,
    text: goldUserTexts.fullDefault,
    needMonetization: false,
    buttonText: upgrade,
    color: fullColor,
    buttonColor: ButtonSkinSecondary
  },
  warning: {
    title: defaultTitle,
    text: goldUserTexts.warningDefault,
    needMonetization: false,
    buttonText: upgrade,
    color: warningColor,
    buttonColor: ButtonSkinSecondary
  }
}, _a$5[USER_SUBSCRIPTION_TYPES.canceled] = {
  "default": {
    title: defaultTitle,
    text: '',
    needMonetization: false,
    buttonText: manageStorage,
    color: defaultColor,
    buttonColor: ButtonSkinPrimary
  },
  full: {
    title: defaultTitle,
    text: goldUserTexts.fullDefault,
    needMonetization: false,
    buttonText: manageStorage,
    color: fullColor,
    buttonColor: ButtonSkinPrimary
  },
  warning: {
    title: defaultTitle,
    text: goldUserTexts.warningDefault,
    needMonetization: true,
    buttonText: manageStorage,
    color: warningColor,
    buttonColor: ButtonSkinPrimary
  }
}, _a$5[USER_SUBSCRIPTION_TYPES.expired] = {
  "default": {
    title: defaultTitle,
    text: freeUserTexts["default"],
    needMonetization: true,
    buttonText: upgrade,
    color: defaultColor,
    buttonColor: ButtonSkinPremium
  },
  full: {
    title: defaultTitle,
    text: expiredUserTexts.fullDefault,
    needMonetization: false,
    buttonText: upgrade,
    color: fullColor,
    buttonColor: ButtonSkinPremium
  },
  warning: {
    title: defaultTitle,
    text: freeUserTexts.warningDefault,
    needMonetization: true,
    buttonText: upgrade,
    color: warningColor,
    buttonColor: ButtonSkinPremium
  }
}, _a$5[USER_SUBSCRIPTION_TYPES.maxStarter] = {
  "default": {
    title: defaultTitle,
    text: '',
    needMonetization: false,
    buttonText: upgrade,
    color: defaultColor,
    buttonColor: ButtonSkinSecondary
  },
  full: {
    title: defaultTitle,
    text: goldUserTexts.fullDefault,
    needMonetization: false,
    buttonText: upgrade,
    color: fullColor,
    buttonColor: ButtonSkinSecondary
  },
  warning: {
    title: defaultTitle,
    text: goldUserTexts.warningDefault,
    needMonetization: false,
    buttonText: upgrade,
    color: warningColor,
    buttonColor: ButtonSkinSecondary
  }
}, _a$5[USER_SUBSCRIPTION_TYPES.maxPerformance] = {
  "default": {
    title: defaultTitle,
    text: '',
    needMonetization: false,
    buttonText: manageStorage,
    color: defaultColor,
    buttonColor: ButtonSkinSecondary
  },
  full: {
    title: defaultTitle,
    text: goldUserTexts.fullDefault,
    needMonetization: false,
    buttonText: manageStorage,
    color: fullColor,
    buttonColor: ButtonSkinSecondary
  },
  warning: {
    title: defaultTitle,
    text: goldUserTexts.warningDefault,
    needMonetization: false,
    buttonText: manageStorage,
    color: warningColor,
    buttonColor: ButtonSkinSecondary
  }
}, _a$5);

var useStyles$4 = createUseStyles({
  root: {
    padding: [Spacings.s12, Spacings.s0, Spacings.s0],
    margin: [Spacings.s12, Spacings.s0, Spacings.s0],
    borderTop: [1, 'solid', ControlBorderColors["default"]]
  },
  button: {
    fontWeight: FontWeights.medium,
    fontSize: FontSizes.s14,
    alignItems: 'center',
    background: 'none',
    cursor: 'pointer',
    color: TextColors.base,
    lineHeight: 1.42,
    gap: Spacings.s8,
    display: 'flex',
    border: 'none',
    width: '100%'
  },
  skeleton: {
    borderRadius: CornerRadius.r8,
    width: '100%',
    height: 32
  },
  label: {
    textAlign: 'start',
    flexGrow: 1
  },
  arrowIcon: {
    fill: SecondaryColors.base["default"],
    height: 32,
    width: 32
  },
  startIcon: {
    fill: TextColors.tint1,
    height: 24,
    width: 24
  }
}, {
  name: 'rc-profile-menu-item'
});

var _a$4;
var HeaderProfileDropdownIcons;
(function (HeaderProfileDropdownIcons) {
  HeaderProfileDropdownIcons["compass"] = "compass";
  HeaderProfileDropdownIcons["settings"] = "settings";
  HeaderProfileDropdownIcons["GiftSubscription"] = "Gift a subscription";
  HeaderProfileDropdownIcons["help"] = "help";
  HeaderProfileDropdownIcons["logout"] = "logout";
  HeaderProfileDropdownIcons["profile"] = "profile";
  HeaderProfileDropdownIcons["referToEarn"] = "referToEarn";
})(HeaderProfileDropdownIcons || (HeaderProfileDropdownIcons = {}));
var ProfileItem;
(function (ProfileItem) {
  ProfileItem["ReferToEarn"] = "Refer to earn";
  ProfileItem["GiftSubscription"] = "Gift a subscription";
  ProfileItem["Settings"] = "Settings";
  ProfileItem["Logout"] = "Log Out";
  ProfileItem["Help"] = "Help";
  ProfileItem["Profile"] = "Profile";
  ProfileItem["Feed"] = "Feed";
  ProfileItem["Team"] = "Team";
})(ProfileItem || (ProfileItem = {}));
var HEADER_PROFILE_DROPDOWN_ICONS = (_a$4 = {}, _a$4[HeaderProfileDropdownIcons.compass] = IconDiscoverOutline, _a$4[HeaderProfileDropdownIcons.settings] = IconSettings, _a$4[HeaderProfileDropdownIcons.help] = IconMessage, _a$4[HeaderProfileDropdownIcons.logout] = IconLogout, _a$4[HeaderProfileDropdownIcons.profile] = IconProfileOutline, _a$4[HeaderProfileDropdownIcons.referToEarn] = IconAds, _a$4[HeaderProfileDropdownIcons.GiftSubscription] = IconGiftBox, _a$4);

var MenuButtonType;
(function (MenuButtonType) {
  MenuButtonType[MenuButtonType["Search"] = 0] = "Search";
  MenuButtonType[MenuButtonType["WithRegistration"] = 1] = "WithRegistration";
  MenuButtonType[MenuButtonType["Negative"] = 2] = "Negative";
})(MenuButtonType || (MenuButtonType = {}));
var ProfileStates;
(function (ProfileStates) {
  ProfileStates[ProfileStates["loading"] = 0] = "loading";
  ProfileStates[ProfileStates["signIn"] = 1] = "signIn";
  ProfileStates[ProfileStates["unauthorized"] = 2] = "unauthorized";
})(ProfileStates || (ProfileStates = {}));
var userRoles;
(function (userRoles) {
  userRoles["imageCreator"] = "image-creator";
  userRoles["stickerCreator"] = "sticker-creator";
  userRoles["default"] = "default";
})(userRoles || (userRoles = {}));

var referToEarnItem = {
  url: '/settings/?activeTab=ReferAndEarn',
  label: ProfileItem.ReferToEarn,
  className: 'default',
  svgName: HeaderProfileDropdownIcons.referToEarn,
  dataTest: 'refer-to-earn-button',
  newBadgeExpirationDate: '2025-04-20'
};
var giftSubscriptionItem = {
  url: '/pricing/special-offer/gift',
  label: ProfileItem.GiftSubscription,
  className: 'default',
  svgName: HeaderProfileDropdownIcons.GiftSubscription,
  dataTest: 'gift-subscription-button',
  openInNewTab: true
};
var profileFeedItem = {
  url: '/feed/',
  label: ProfileItem.Feed,
  className: 'default',
  svgName: HeaderProfileDropdownIcons.compass,
  dataTest: 'feed-button'
};
var logoutProfileItem = {
  label: ProfileItem.Logout,
  className: 'log-out',
  svgName: HeaderProfileDropdownIcons.logout,
  dataTest: 'logout-button',
  dataTestId: 'header-profile-content-logout-button'
};
var profileItems = [giftSubscriptionItem, {
  url: '/settings/',
  label: ProfileItem.Settings,
  className: 'default',
  svgName: HeaderProfileDropdownIcons.settings,
  dataTest: 'settings-button'
}, {
  url: 'https://support.picsart.com/hc/en-us',
  label: ProfileItem.Help,
  className: 'default',
  svgName: HeaderProfileDropdownIcons.help,
  dataTest: 'help-button'
}];

var _a$3, _b$2, _c, _d;
var useStyles$3 = createUseStyles({
  root: {
    minWidth: 330,
    whiteSpace: 'nowrap'
  },
  header: {
    border: "1px solid ".concat(BackgroundColors.tint3),
    borderRadius: CornerRadius.r8,
    padding: Spacings.s12
  },
  userProfile: {
    whiteSpace: 'nowrap'
  },
  user: (_a$3 = {
    padding: [Spacings.s16, Spacings.s12, Spacings.s24, Spacings.s12]
  }, _a$3[canHover] = {
    '&:hover': {
      '& $userTitle': {
        color: PrimaryColors.base["default"]
      },
      '& svg': {
        '& > path': {
          fill: PrimaryColors.base["default"]
        }
      }
    }
  }, _a$3),
  userTitle: {
    display: 'block',
    height: 24,
    fontWeight: FontWeights.semibold,
    fontSize: FontSizes.s16,
    color: TextColors.tint1,
    lineHeight: LineHeights.l24
  },
  userArrowIcon: (_b$2 = {
    display: 'inline-block',
    verticalAlign: 'baseline',
    width: 12,
    height: 12,
    fill: BackgroundColors.tint3
  }, _b$2[isRightToLeft] = {
    transform: 'rotate(180deg)'
  }, _b$2),
  text: {
    fontWeight: FontWeights.medium,
    fontSize: FontSizes.s14,
    whiteSpace: 'initial',
    textAlign: 'center',
    minWidth: '270px',
    lineHeight: 1.42
  },
  upgradeBtn: {
    width: '100%',
    margin: [Spacings.s8, Spacings.s0]
  },
  username: {
    fontWeight: FontWeights.bold,
    marginBottom: Spacings.s12,
    fontSize: FontSizes.s16,
    marginTop: Spacings.s8,
    textAlign: 'center',
    lineHeight: 1.5
  },
  skeleton: {
    margin: [Spacings.s8, Spacings.s0],
    borderRadius: CornerRadius.r20,
    width: '100%',
    height: 40
  },
  userLink: (_c = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    height: 44,
    marginBottom: Spacings.s2,
    position: 'relative',
    fontWeight: FontWeights.semibold,
    fontSize: FontSizes.s16,
    lineHeight: LineHeights.l48,
    transition: "color ".concat(Timings["default"], " ").concat(Easing.easeInOut),
    cursor: 'pointer',
    '&.default': {
      color: TextColors.tint1
    },
    '&.log-out': {
      color: ErrorColors.base["default"],
      background: 'none',
      border: 'none',
      '&:hover': {
        color: ErrorColors.base.action
      }
    }
  }, _c[canHover] = {
    '&:hover': {
      color: PrimaryColors.base["default"]
    }
  }, _c[canTouch] = {
    '&:focus': {
      color: PrimaryColors.base["default"]
    }
  }, _c['&:not(:hover):focus'] = {
    color: PrimaryColors.base["default"]
  }, _c['&:last-child'] = {
    marginBottom: Spacings.s0
  }, _c),
  userLinkIcon: (_d = {
    display: 'inline-block',
    width: 24,
    height: 24,
    fill: TextColors.tint1
  }, _d[isLeftToRight] = {
    marginRight: Spacings.s24
  }, _d[isRightToLeft] = {
    marginLeft: Spacings.s24
  }, _d),
  avatar: {
    display: 'flex',
    justifyContent: 'center'
  },
  contributorWrapper: {
    position: 'relative',
    padding: [Spacings.s16, Spacings.s12],
    borderTop: "1px solid ".concat(SecondaryColors.base["default"])
  },
  contributorCollectiveLink: {
    textDecoration: 'none',
    '&:hover > div': {
      color: PrimaryColors.base["default"]
    }
  },
  contributorText: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    fontSize: FontSizes.s16,
    fontWeight: FontWeights.semibold,
    color: NegativeColors.text["default"],
    transition: "color ".concat(Timings["default"], " ").concat(Easing.easeInOut),
    '& > span': {
      padding: [Spacings.s8, Spacings.s12, Spacings.s6],
      marginLeft: Spacings.s6,
      fontSize: FontSizes.s14,
      backgroundColor: NegativeColors.base["default"],
      textTransform: 'uppercase',
      color: NegativeColors.text["default"],
      borderRadius: CornerRadius.r16,
      transition: "color ".concat(Timings["default"], " ").concat(Easing.easeInOut)
    }
  },
  team: {
    margin: [Spacings.s16, Spacings.s0, Spacings.s24],
    padding: [Spacings.s8, Spacings.s12],
    position: 'relative',
    cursor: 'pointer',
    border: 'none',
    backgroundColor: 'transparent',
    textAlign: 'left'
  },
  teamBottom: {
    display: 'flex',
    alignItems: 'center'
  },
  teamTop: {
    fontWeight: FontWeights.semibold,
    fontSize: FontSizes.s16,
    marginBottom: Spacings.s6
  },
  teamImg: {
    width: 24,
    height: 24,
    minWidth: 24,
    borderRadius: '100%',
    overflow: 'hidden',
    backgroundColor: BackgroundColors.tint3,
    marginRight: Spacings.s16,
    backgroundImage: 'url(https://cdn140.picsart.com/96964700141004781209.png)',
    backgroundRepeat: 'round',
    marginTop: Spacings.s4
  },
  teamName: {
    fontSize: FontSizes.s16,
    lineHeight: 1.4,
    width: 160,
    fontWeight: FontWeights.semibold,
    wordBreak: 'break-word',
    whiteSpace: 'pre-line',
    overflowWrap: 'break-word'
  },
  userLinkLabel: {
    flexGrow: 1
  }
}, {
  name: 'rc-header-dev-top-profile-content'
});

var _a$2, _b$1;
var useStyles$2 = createUseStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    position: 'relative',
    '& .profile': {
      display: 'block'
    }
  },
  button: (_a$2 = {
    position: 'relative',
    display: 'block',
    border: 'none',
    backgroundColor: 'transparent',
    transitionProperty: 'background-color, color',
    transitionDuration: Timings["default"],
    transitionTimingFunction: Easing.easeInOut,
    cursor: 'pointer'
  }, _a$2[isLeftToRight] = {
    paddingRight: Spacings.s24
  }, _a$2[isRightToLeft] = {
    paddingLeft: Spacings.s24
  }, _a$2[canHover] = {
    '&:hover, &:focus': {
      '& $avatarIcon': {
        '& > svg': {
          '& > path': {
            fill: PrimaryColors.base["default"]
          }
        }
      },
      '& $icon': {
        fill: PrimaryColors.base["default"]
      }
    }
  }, _a$2[canTouch] = {
    '&:focus': {
      '& $avatarIcon': {
        '& > svg': {
          '& > path': {
            fill: PrimaryColors.base["default"]
          }
        }
      },
      '& $icon': {
        '& > svg': {
          '& > path': {
            fill: PrimaryColors.base["default"]
          }
        }
      }
    }
  }, _a$2['&:active'] = {
    '& $imageOuterHolder': {
      '&:before': {
        transform: 'scale(1)',
        opacity: 1
      }
    }
  }, _a$2),
  icon: (_b$1 = {
    display: 'inline-block',
    width: 12,
    height: 12,
    position: 'absolute',
    top: Spacings.s0,
    bottom: Spacings.s0,
    margin: ['auto', Spacings.s0],
    transitionProperty: 'background-color, color',
    transitionDuration: Timings["default"],
    transitionTimingFunction: Easing.easeInOut
  }, _b$1[isLeftToRight] = {
    right: Spacings.s8
  }, _b$1[isRightToLeft] = {
    left: Spacings.s8
  }, _b$1),
  '& > svg': {
    '& > path': {
      transition: "fill ".concat(Timings["default"], " ").concat(Easing.easeInOut)
    }
  },
  imageOuterHolder: {
    display: 'block',
    width: 40,
    height: 40,
    borderRadius: CornerRadius.r8,
    position: 'relative',
    '&:before': {
      content: "''",
      display: 'block',
      position: 'absolute',
      top: -4,
      right: -4,
      bottom: -4,
      left: -4,
      margin: 'auto',
      border: "2px solid ".concat(BackgroundColors.base),
      borderRadius: CornerRadius.circle,
      opacity: 0,
      transform: 'scale(0.8)',
      transitionProperty: 'opacity, transform',
      transitionDuration: Timings["default"],
      transitionTimingFunction: Easing.easeInOut
    }
  },
  notificationCircle: {
    width: 8,
    height: 8,
    backgroundColor: ErrorColors.base.active,
    borderRadius: CornerRadius.circle,
    display: 'flex',
    position: 'absolute',
    right: Spacings.s0,
    bottom: Spacings.s4
  },
  tooltip: {
    textAlign: 'center',
    marginLeft: -11,
    maxWidth: 236
  }
}, {
  name: 'rc-header-dev-profile'
});

var profileStates;
(function (profileStates) {
  profileStates[profileStates["loading"] = 0] = "loading";
  profileStates[profileStates["signIn"] = 1] = "signIn";
  profileStates[profileStates["unauthorized"] = 2] = "unauthorized";
})(profileStates || (profileStates = {}));

var _a$1, _b;
var useStyles$1 = createUseStyles({
  user: {
    display: 'inline-block'
  },
  section: {
    height: '100%',
    '&.right': (_a$1 = {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'right'
    }, _a$1[isLeftToRight] = {
      marginLeft: 'auto'
    }, _a$1[isRightToLeft] = {
      marginRight: 'auto'
    }, _a$1)
  },
  monetizationButton: (_b = {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: SecondaryColors.base["default"],
    padding: [Spacings.s10, Spacings.s16, Spacings.s10, Spacings.s48],
    color: NegativeColors.text["default"]
  }, _b[mediaQuery(BreakPoints.Medium)] = {
    display: 'none'
  }, _b),
  monetizationButtonIcon: {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    height: 26,
    left: 16,
    '& svg': {
      fill: NegativeColors.text["default"]
    }
  },
  monetizationButtonWrapper: {
    position: 'relative',
    marginRight: Spacings.s12
  },
  createExperimentButtonStyle: {
    marginRight: Spacings.s8,
    background: PrimaryColors.base["default"],
    color: NegativeColors.text["default"],
    '@media screen and (max-width: 500px)': {
      marginLeft: Spacings.s8
    }
  },
  searchInput: {
    marginRight: Spacings.s12,
    '@media screen and (max-width: 500px)': {
      marginRight: function marginRight(props) {
        return (props === null || props === void 0 ? void 0 : props.showBraze) ? 0 : Spacings.s12;
      }
    }
  },
  searchIcon: {
    width: 40,
    height: 40,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: Spacings.s12,
    backgroundColor: BackgroundColors.tint2,
    borderRadius: CornerRadius.circle,
    '@media screen and (max-width: 500px)': {
      marginRight: function marginRight(props) {
        return (props === null || props === void 0 ? void 0 : props.showBraze) ? 0 : Spacings.s12;
      }
    }
  }
}, {
  name: 'rc-header-dev'
});

var _a;
var useStyles = createUseStyles({
  root: {
    display: 'block',
    height: 40,
    padding: [Spacings.s0, Spacings.s12],
    borderRadius: CornerRadius.r8,
    fontWeight: FontWeights.semibold,
    fontSize: FontSizes.s14,
    whiteSpace: 'nowrap',
    position: 'relative',
    border: 'none',
    transitionProperty: 'background-color, color',
    transitionDuration: Timings["default"],
    transitionTimingFunction: Easing.easeInOut,
    cursor: 'pointer',
    '&:before': {
      content: "''",
      display: 'block',
      position: 'absolute',
      top: -1,
      right: -1,
      bottom: -1,
      left: -1,
      zIndex: -1,
      margin: 'auto',
      borderWidth: 2,
      borderStyle: 'solid',
      borderColor: 'transparent',
      borderRadius: CornerRadius.r8,
      opacity: 0,
      transitionProperty: 'opacity, top, right, bottom, left',
      transitionDuration: Timings.fast,
      transitionTimingFunction: Easing.easeInOut,
      transform: 'translate3d(0, 0, 0)'
    },
    '&:first-letter': {
      textTransform: 'capitalize'
    },
    '&.sign': (_a = {
      backgroundColor: '#262626',
      color: AbsolutesBlackColors.text["default"],
      '&:before': {
        borderColor: '#262626'
      }
    }, _a[canHover] = {
      '&:hover': {
        backgroundColor: '#262626'
      }
    }, _a[canTouch] = {
      '&:active': {
        backgroundColor: '#262626'
      }
    }, _a),
    '&:active': {
      '&:before': {
        top: -4,
        right: -4,
        bottom: -4,
        left: -4,
        zIndex: 'initial',
        opacity: 1
      }
    }
  }
}, {
  name: 'rc-header-dev-button'
});

export { AppSmartBanner as A, BUTTON_TYPES as B, DRIVE_ANALYTICS_SOURCE_KEY as D, Header as H, MenuButtonType as M, ProfileItem as P, STORAGE_STATES as S, ProfileStates as a, userRoles as b, useStyles$5 as c, userStorageData as d, useStyles$4 as e, useStyles$3 as f, HEADER_PROFILE_DROPDOWN_ICONS as g, HeaderProfileDropdownIcons as h, profileItems as i, profileFeedItem as j, ANALYTIC_EVENTS as k, logoutProfileItem as l, StorageOrigins as m, StorageSources as n, DriveAnalyticsSourceOptions as o, profileStates as p, useStyles$2 as q, referToEarnItem as r, useStyles as s, useStyles$1 as u };
//# sourceMappingURL=styles-4a961839.js.map
